import { createRouter, createWebHistory } from 'vue-router';
import NProgress from 'nprogress';
import { handleHotUpdate } from 'vue-router/auto-routes';
import { setRouteEmitter, useMenuStore, useSettingsStore } from '@/layouts/sfapp';
import { constantRoutes, fileSystemRoutes } from './routes';
import { projectSettings } from '@/settings/index';

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHistory(projectSettings.route?.baseURL),
  routes: projectSettings.route?.baseOn === 'frontend' ? constantRoutes : fileSystemRoutes,
});

if (import.meta.hot && projectSettings.route?.baseOn === 'filesystem') {
  handleHotUpdate(router);
}

router.beforeEach(async (to, from) => {
  const { settings } = useSettingsStore();
  const menuStore = useMenuStore();

  setRouteEmitter(to);
  NProgress.start();

  // head-side 模式下设置主导航激活菜单
  settings.menu.menuMode === 'head-side' && menuStore.setActived(to.path);

  return true;
});

router.afterEach(async (to, from) => {
  NProgress.done();
  return true;
});

export default router;
